/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nutrition_Estimate_TitleInputs */

const en_nutrition_estimate_title = /** @type {(inputs: Nutrition_Estimate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated`)
};

const de_nutrition_estimate_title = /** @type {(inputs: Nutrition_Estimate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzt`)
};

/**
* | output |
* | --- |
* | "Estimated" |
*
* @param {Nutrition_Estimate_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrition_estimate_title = /** @type {((inputs?: Nutrition_Estimate_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrition_Estimate_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrition_estimate_title(inputs)
	return en_nutrition_estimate_title(inputs)
});